export default (client) => {
  return {
    subscribe(email, trackingData = null) {
      const config = {}

      if (trackingData) {
        config.params = { track: JSON.stringify(trackingData) }
      }

      return client.post(`/saas/newsletter/subscribe/`, { email }, config)
    },
  }
}
